import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { SectionHeader } from '../ui/SectionHeader';
const bonuses = [{
  tag: 'B1',
  title: 'Kit de rutinas visuales',
  desc: 'Tarjetas imprimibles para la mañana, la tarde y la noche. Tu hijo sabe qué viene después sin que repitas veinte veces.',
  img: 'https://images.unsplash.com/photo-1506784983877-45594efa4cbe?auto=format&fit=crop&w=200&q=55',
  alt: 'Calendario y tarjetas de rutina diaria'
}, {
  tag: 'B2',
  title: 'Guía de comunicación para el momento difícil',
  desc: 'Las frases exactas para hablar con tu hijo cuando está frustrado, no quiere estudiar o explota.',
  img: 'https://images.unsplash.com/photo-1516627145497-ae6968895b74?auto=format&fit=crop&w=200&q=55',
  alt: 'Madre conversando con su hijo'
}, {
  tag: 'B3',
  title: 'Registro de progreso mensual',
  desc: 'Planilla para registrar los avances mes a mes y ver con claridad todo lo que ya cambió.',
  img: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&w=200&q=55',
  alt: 'Planilla de seguimiento de progreso'
}, {
  tag: 'B4',
  title: 'Glosario para mamás y papás',
  desc: 'Todos los términos del colegio, la obra social y el consultorio explicados en lenguaje simple.',
  img: 'https://images.unsplash.com/photo-1544716278-ca5e3f4abd8c?auto=format&fit=crop&w=200&q=55',
  alt: 'Libro abierto a modo de glosario'
}, {
  tag: 'B5',
  title: 'Plan de acción de 30 días',
  desc: 'Un calendario con las primeras acciones concretas para empezar desde el día uno, paso a paso.',
  img: 'https://images.unsplash.com/photo-1484480974693-6ca0a78fb36b?auto=format&fit=crop&w=200&q=55',
  alt: 'Calendario de plan de 30 días'
}, {
  tag: 'B6',
  title: 'Kit de autonomía diaria',
  desc: 'Tarjetas para los momentos más conflictivos: levantarse, la mochila, la tarea, bañarse y dormir.',
  img: 'https://images.unsplash.com/photo-1503454537195-1dcabb73ffb9?auto=format&fit=crop&w=200&q=55',
  alt: 'Niño preparando su mochila para el colegio'
}];
export function Bonuses() {
  return <section className="py-12 md:py-20 bg-white" data-id="element-31">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-32">
        <SectionHeader title="INCLUIDOS GRATIS — 6 Bonos de uso inmediato" subtitle="Sin costo extra — incluidos en todas las ofertas" data-id="element-33" />

        {/* Compact horizontal rows */}
        <div className="grid sm:grid-cols-2 gap-3 md:gap-4 mb-8 md:mb-12" data-id="element-34">
          {bonuses.map((bonus, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.05
        }} whileHover={{
          y: -2
        }} className="flex items-center gap-3 md:gap-4 bg-[#FBF7F0] border border-[#1E2A4A]/10 rounded-xl p-3 md:p-4 shadow-sm" data-id="element-35">
              <img src={bonus.img} alt={bonus.alt} width={72} height={72} loading="lazy" decoding="async" className="w-16 h-16 md:w-[72px] md:h-[72px] rounded-lg object-cover shrink-0 bg-[#1E2A4A]/5" data-id="element-36" />

              <div className="min-w-0 flex-1" data-id="element-37">
                <div className="flex items-center gap-2 mb-0.5" data-id="element-38">
                  <span className="text-[10px] md:text-xs font-bold text-[#1E2A4A]/40" data-id="element-39">
                    {bonus.tag}
                  </span>
                  <span className="bg-[#8A9A86]/15 text-[#4A5D46] text-[9px] md:text-[10px] font-bold px-1.5 py-0.5 rounded uppercase tracking-wide" data-id="element-40">
                    Gratis
                  </span>
                </div>
                <h3 className="text-sm md:text-base font-bold text-[#1E2A4A] leading-tight mb-0.5" data-id="element-41">
                  {bonus.title}
                </h3>
                <p className="text-[#1E2A4A]/70 text-xs md:text-sm leading-snug line-clamp-2" data-id="element-42">
                  {bonus.desc}
                </p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-[#1E2A4A] rounded-2xl p-5 md:p-8 text-center max-w-2xl mx-auto" data-id="element-43">
          <p className="text-xl md:text-3xl font-bold text-white" data-id="element-44">
            VALOR TOTAL:{' '}
            <span className="line-through text-white/50 decoration-red-500 decoration-4" data-id="element-45">
              $53.490
            </span>{' '}
            — <span className="text-[#E76F51]" data-id="element-46">GRATIS</span>
          </p>
        </motion.div>
      </div>
    </section>;
}